import { getItem, storageKey } from "./utilis/methods/storage/storage";
export const origin = (window as any)._env_?.API_BASE_URL;
export const insuranceUrl = (window as any)._env_?.VITE_API_URL;
export const base = (window as any)._env_?.BASE_URL;
export const baseURL = `${origin}${base}`;
export const assetsUrl = `${window.location.origin}/assets`;
export const websocketServiceUrl =
  import.meta.env.VITE_WEBSOCKET_SERVICE_URL || "/web-socket-service";

const storageClinicId = localStorage.getItem(storageKey.clinicId);
// const storageCreatedById = getItem(storageKey.createdById);
export const clinicId =  parseInt(storageClinicId as string)
export const user = getItem(storageKey.USER)
console.log("user inside constant => ",user)
export const userType = user?.groupId;
// export const createdById = storageCreatedById
//   ? parseInt(storageCreatedById)
//   : null;
export const createdById = Number(user?.userId)
export const groupName = getItem(storageKey.groupName) || null;
export const groupId = 3;
export const clinicianId = user?.clinicianID

export const userTypes = ["DOCTOR", "ADMIN"];
export const customIcons = {
  'flaticon-home': 'HomeOutlined',
  'fa flaticon-clipboard': 'AssignmentOutlined',
  'fa flaticon-file-1': 'NoteAltOutlined',
  ' flaticon-add': 'LibraryAddOutlined',
  ' flaticon-list': 'DocumentScannerOutlined',
  '  flaticon-support': 'ContactPhoneOutlined',
  ' flaticon-users': 'PeopleAltOutlined',
  '  flaticon-price-tag': 'RequestQuoteOutlined',
  'flaticon-safe-shield-protection': 'VerifiedUserOutlined',
  ' flaticon-download': 'SaveAltOutlined',
  'flaticon-business': 'TrendingUpOutlined',
  'flaticon-user': 'PermIdentityOutlined',
  'flaticon-diagram': 'AssessmentOutlined',
  'flaticon-interface-1': 'Inventory2Outlined'
}